import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// "Pozisyona Davet Et" sonucunun özeti: kaç davet GİTTİ + kim hangi NEDENLE atlandı.
// Sunucu kısmi başarıyı gövdede taşır (`{ sent, skipped: [{candidateId, reason}] }`);
// tek bir "tamam" toast'ı rızası geçmiş/anonim/yakın zamanda davet edilmiş adayları
// sessizce yutardı — kullanıcı kime mail gitmediğini BİLMELİ.
const Box = styled.div`
  padding: 10px 14px;
  margin-bottom: 12px;
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.surface.card};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const Summary = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const DismissBtn = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

const SkippedTitle = styled.div`
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.auxiliar.danger};
`;

const SkippedRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.auxiliar.danger};
  padding: 6px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.surface.border};
  &:last-child { border-bottom: none; }
`;

// Neden kodu → metin: önce havuza özel anahtar, yoksa sunucu hata sözlüğü, yoksa ham kod.
export const skipReasonLabel = (t, reason) => t(`ats.candidatePool.skipReason.${reason}`, {
  defaultValue: t(`responseErrors.${reason}`, { defaultValue: reason || '-' }),
});

export default function InviteResultPanel({ result, nameOf, onDismiss }) {
  const { t } = useTranslation();
  if (!result) return null;
  const skipped = result.skipped || [];
  return (
    <Box data-role="ats-invite-result">
      <Header>
        <Summary data-role="ats-invite-result-summary">
          {t('ats.candidatePool.inviteResultSent', { count: result.sentCount })}
          {skipped.length > 0 && ` · ${t('ats.candidatePool.inviteResultSkipped', { count: skipped.length })}`}
        </Summary>
        {onDismiss && (
          <DismissBtn type="button" aria-label={t('common.close')} onClick={onDismiss}>×</DismissBtn>
        )}
      </Header>
      {skipped.length > 0 && (
        <>
          <SkippedTitle>{t('ats.candidatePool.inviteSkippedTitle')}</SkippedTitle>
          {skipped.map((item) => (
            <SkippedRow key={`${item.candidateId}-${item.reason}`} data-role="ats-invite-skipped-row">
              <span>{(nameOf && nameOf(item.candidateId)) || item.candidateId}</span>
              <span data-role="ats-invite-skipped-reason">{skipReasonLabel(t, item.reason)}</span>
            </SkippedRow>
          ))}
        </>
      )}
    </Box>
  );
}
